import './PersonInfoTabContent.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Col, Descriptions, Row, Table } from 'antd'
import BRDImage from './img/BRDicon.gif'
import OOLImage from './img/OOLicon.gif'
import PEPImage from './img/PEPicon.gif'
import RCAImage from './img/RCAicon.gif'
import SANImage from './img/SANicon.gif'
import SOCImage from './img/SOCicon.gif'
import SIImage from './img/SIicon.gif'
import apiConfig from '../../../../config/api'

const objImages = { BRDImage, OOLImage, PEPImage, RCAImage, SANImage, SOCImage, SIImage}

const PersonInfoTabContent = ({ person }) => {
  const { t } = useTranslation()

  const getFormatDate = (day, month, year) => {
    let fecha = ''
    if (day !== null && day !== '') {
      fecha = fecha + day + '/'
    }
    if (month !== null && month !== '') {
      fecha = fecha + month + '/'
    }
    if (year !== null && year !== '') {
      fecha = fecha + year
    }
    return fecha
  }

  const documentsTableColumns = [
    {
      title: t('messages.aml.type'),
      dataIndex: 'type'
    },
    {
      title: t('messages.aml.number'),
      dataIndex: 'value'
    },
    {
      title: t('messages.aml.comments'),
      dataIndex: 'notes',
      render: (text) => {
        if (text === null) {
          return 'N/A'
        } else {
          return text
        }
      }
    }
  ]

  const regionsTableColumns = [
    {
      title: t('messages.aml.type'),
      dataIndex: 'type',
      width: 200
    },
    {
      title: t('messages.aml.country'),
      dataIndex: 'country.name',
      width: 200
    },
    {
      title: t('messages.aml.sanctions'),
      dataIndex: 'country.sanctions',
      render: (text) => {
        if (text !== null) {
          let sanciones = []
          text.map(sanction =>
            sanciones.push(<p class={'dj-country dj-country-' + sanction }>{ t('messages.dj.countries.'+sanction) } </p>)
          )
          return sanciones
        }
      }
    }
  ]

  const sanctionsTableColumns = [
    {
      title: t('messages.aml.list'),
      dataIndex: 'sancionList.name'
    },
    {
      title: t('messages.aml.from'),
      dataIndex: 'sinceDay',
      render: (text, record) => {
        return getFormatDate(record.sinceDay, record.sinceMonth, record.sinceYear)
      }
    },
    {
      title: t('messages.aml.to'),
      dataIndex: 'toDay',
      render: (text, record) => {
        return getFormatDate(record.toDay, record.toMonth, record.toYear)
      }
    }
  ]

  const rolesTableColumns = [
    {
      title: t('messages.aml.type'),
      dataIndex: 'type'
    },
    {
      title: t('messages.aml.category'),
      dataIndex: 'occupation.name'
    },
    {
      title: t('messages.aml.position'),
      dataIndex: 'desc'
    },
    {
      title: t('messages.aml.from'),
      dataIndex: 'sinceDay',
      render: (text, record) => {
        return getFormatDate(record.sinceDay, record.sinceMonth, record.sinceYear)
      }
    },
    {
      title: t('messages.aml.to'),
      dataIndex: 'toDay',
      render: (text, record) => {
        return getFormatDate(record.toDay, record.toMonth, record.toYear)
      }
    }
  ]

  const aliasTableColumns = [
    {
      title: t('messages.aml.name'),
      dataIndex: 'primaryName',
      render: (text, record) => {
        if(record.primaryName !== '') {
          return record.primaryName
        } else {
          return record.entityName
        }
      }
    },
    {
      title: t('messages.aml.middleName'),
      dataIndex: 'middleName'
    },
    {
      title: t('messages.aml.lastName'),
      dataIndex: 'surName'
    },
    {
      title: t('messages.aml.originalScriptName'),
      dataIndex: 'originalScriptName',
      render: (originalScriptName) => {
        let aliases = []
        originalScriptName.map(script =>
            aliases.push(<p class="script">{ script }</p>)
        )
        return aliases
      }
    }
  ]

  const fechaTableColumns = [
    {
      title: t('messages.aml.type'),
      dataIndex: 'type'
    },
    {
      title: t('messages.aml.date'),
      dataIndex: 'date'
    }
  ]

  const addressesTableColumns = [
    {
      title: t('messages.aml.address'),
      dataIndex: 'address'
    },
    {
      title: t('messages.aml.title.city'),
      dataIndex: 'city'
    },
    {
      title: t('messages.aml.title.country'),
      dataIndex: 'country.name'
    }
  ]

  const getImages = (types) => {
    if(types !== null) {
      let images = []
      types.map(image => {
        images.push(<img src={ objImages[image+'Image'] } class='img-clasif' alt=""/>)
      })
      return images
    }
  }

  const relationsTableColumns = [
    {
      title: t('messages.aml.classification'),
      dataIndex: 'related.types',
      render: (types) => {
        return getImages(types)
      }
    },
    {
      title: t('messages.aml.name'),
      dataIndex: 'related.primaryName.formatName'
    },
    {
      title: t('messages.aml.type'),
      dataIndex: 'related.type'
    },
    {
      title: t('messages.aml.relationship'),
      dataIndex: 'relation.name'
    }
  ]

  const descriptionsColumns = [
   {
    title: "Categoría1",
    render: (description) => {
      if(description.level === '1') return description.name
      else if(description.level === '2') return description.parent?.name
      else if(description.level === '3') return description.parent?.parent?.name
    }
   },
   {
    title: "Categoría2",
    render: (description) => {
      if(description.level === '2') return description.name
      else if(description.level === '3') return description.parent?.name
    }
   },
   {
    title: "Categoría3",
    render: (description) => {
      if(description.level === '3') return description.name
    }
   }
  ]

  const getRelations = (relations) => {
    let related = []
    relations.map(relation => {
        if (relation.related !== null) {
          related.push(relation)
        }
    })
    return related
  }

  const getFechas = (recod) => {
      let fechas = []

      if (recod.dateOfBirth !== undefined && recod.dateOfBirth !== null && recod.dateOfBirth.year !== null) {
        fechas.push({type: t('messages.aml.birthDate'), date: getFormatDate(recod.dateOfBirth.day, recod.dateOfBirth.month, recod.dateOfBirth.year)})
      }
      if (recod.dateDeceased !== undefined && recod.dateDeceased !== null && recod.dateDeceased.year !== null) {
        fechas.push({type: t('messages.aml.deathDate'), date: getFormatDate(recod.dateDeceased.day, recod.dateDeceased.month, recod.dateDeceased.year)})
      }
      if (recod.dateOfRegistration !== undefined && recod.dateOfRegistration !== null && recod.dateOfRegistration.year !== null) {
        fechas.push({type: t('messages.aml.registerDate'), date: getFormatDate(recod.dateOfRegistration.day, recod.dateOfRegistration.month, recod.dateOfRegistration.year)})
      }
      return fechas
  }

  const getTitle = (text) => {
    let title

    switch(text) {
      case 'pfa':
        title = 'Watchlist'
        break
      case 'soc':
        title = 'State Owned Companies'
        break
      default:
        title = 'Adverse Media'
        break
    }

    return title
  }

  const urlify = (text) => {
    var urlRegex = /(https?:\/\/[^\s]+)/g

    return text.replace(urlRegex, (url) => {
      return '<a href="' + url + '" target="_blank">' + url + '</a>'
    })
  }

  let related = []
  if (person.relations !== undefined && person.relations !== null && person.relations.length > 0) {
    related = getRelations(person.relations)
  }

  return (
    <div className="person-info">
      <h3 className="basic-info-title">Basic Information</h3>
      <div className="basic-info">
        <Row>
          <Col xs={12}>
            <label>{t("messages.aml.title.profileNumber")}</label>
            <p>{ person.id }</p>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <label>{t("messages.aml.status")}</label>
            <p>{ person.activeStatus }</p>
          </Col>
          <Col xs={12}>
            <label>{t("messages.aml.type")}</label>
            <p>{ person.type }</p>
          </Col>
          
        </Row>
        <Row>
          <Col xs={12}>
            <label>{t("messages.aml.classification")}</label>
            <p>{ getImages(person.types) }</p>
          </Col>
          <Col xs={12}>
            <label>{t("messages.aml.register.table.titles.lastUpdate")}</label>
            <p>{ person.date }</p>
          </Col>
        </Row>
        
        { (person.type === 'Person') &&
          <Row>
            <Col xs={12}>
              <label>{t("messages.aml.title.gender")}</label>
              <p>{ person.gender }</p>
            </Col>
            <Col xs={12}>
              <label>{t("messages.aml.title.deceased")}</label>
              <p>{ person.deceased }</p>
            </Col>
          </Row>
        }
        <Row>
          <Col xs={12}>
            <label>{t("messages.aml.name")}</label>
            <p>
              {
                person.type === 'Person' ?
                  person.primaryName.primaryName
                  :
                  person.primaryName.entityName
              }
            </p>
          </Col>
          <Col xs={12}>
            <label>{t("messages.aml.middleName")}</label>
            <p>{ person.primaryName.middleName }</p>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <label>{t("messages.aml.lastName")}</label>
            <p>{ person.primaryName.surName }</p>
          </Col>
          <Col xs={12}>
            <label>{t("messages.aml.originalScriptName")}</label>
            { person.primaryName.originalScriptName.map(script => <p class="script">{ script }</p>) }
          </Col>
        </Row>
      </div>
      <Descriptions layout="vertical" size="small" column={4} bordered>

        { (person.aliases !== undefined && person.aliases !== null && person.aliases.length > 0) &&
          <Descriptions.Item label={ t('messages.aml.title.alias') } span={4}>
            <Table dataSource={ person.aliases } columns={ aliasTableColumns } pagination={ false } size='small' />
          </Descriptions.Item>
        }
        { (person.lowAliases !== undefined && person.lowAliases !== null && person.lowAliases.length > 0) &&
          <Descriptions.Item label={ t('messages.aml.lowAliases')} span={4}>
            <Table dataSource={ person.lowAliases } columns={ aliasTableColumns } pagination={ false } size='small' />
          </Descriptions.Item>
        }
        { (person.spellingVariation !== undefined && person.spellingVariation !== null && person.spellingVariation.length > 0) &&
          <Descriptions.Item label={ t('messages.aml.aliasVariations')} span={4}>
            <Table dataSource={ person.spellingVariation } columns={ aliasTableColumns } pagination={ false } size='small' />
          </Descriptions.Item>
        }
        { (person.formerlyAliases !== undefined && person.formerlyAliases !== null && person.formerlyAliases.length > 0) &&
          <Descriptions.Item label={ t('messages.aml.formerlyAliases') } span={4}>
            <Table dataSource={ person.formerlyAliases } columns={ aliasTableColumns } pagination={ false } size='small' />
          </Descriptions.Item>
        }{ (person.languageVariation !== undefined && person.languageVariation !== null && person.languageVariation.length > 0) &&
          <Descriptions.Item label={ t('messages.aml.languageVariation') } span={4}>
            <Table dataSource={ person.languageVariation } columns={ aliasTableColumns } pagination={ false } size='small' />
          </Descriptions.Item>
        }

        { (person.images && person.images.length > 0) &&
          <Descriptions.Item className="images" label={ t('messages.aml.photographies') } span={4}>
            { person.images.map(imgUrl => <img src={ apiConfig.url + "/getImageDJ?imageUrl=" + encodeURI(imgUrl) } alt="" style={{ height: '100px' }} />) }
          </Descriptions.Item>
        }
        { (person.countryDetails !== undefined && person.countryDetails !== null && person.countryDetails.length > 0) &&
          <Descriptions.Item label={ t('messages.aml.regions') } span={4}>
            <Table dataSource={ person.countryDetails } columns={ regionsTableColumns } pagination={ false } size='small' />
          </Descriptions.Item>
        }

        { ((person.dateOfBirth !== undefined && person.dateOfBirth !== null && person.dateOfBirth.year !== null) || (person.dateDeceased !== undefined && person.dateDeceased !== null && person.dateDeceased.year !== null) || (person.dateOfRegistration !== undefined && person.dateOfRegistration !== null && person.dateOfRegistration.year !== null)) && (
            <Descriptions.Item label={ t('messages.aml.dates') } span={4}>
              <Table dataSource={ getFechas(person) } columns={ fechaTableColumns } pagination={ false } size='small' />
            </Descriptions.Item>
          )
        }
        {
          (person.roles !== undefined && person.roles !== null && person.roles.length > 0) &&
          <Descriptions.Item label={ t('messages.aml.positions') } span={4}>
            <Table dataSource={ person.roles } columns={ rolesTableColumns } pagination={ false } size='small' />
          </Descriptions.Item>
        }
        {
          (person.addresses !== undefined && person.addresses !== null && person.addresses.length > 0) &&
          <Descriptions.Item label={ t('messages.aml.addresses') } span={4}>
            <Table dataSource={ person.addresses } columns={ addressesTableColumns } pagination={ false } size='small' />
          </Descriptions.Item>
        }
        { (person.sanctionsList !== undefined && person.sanctionsList !== null && person.sanctionsList.length > 0) &&
          <Descriptions.Item label={ t('messages.aml.sanctions') } span={4}>
            <Table dataSource={ person.sanctionsList } columns={ sanctionsTableColumns } pagination={ false } size="small" />
          </Descriptions.Item>
        }
        { (related.length > 0) &&
          <Descriptions.Item label={ t('messages.aml.related') } span={4}>
            <Table dataSource={ related } columns={ relationsTableColumns } pagination={ true } size="small" />
          </Descriptions.Item>
        }
        {
          (person.documentList !== undefined && person.documentList !== null && person.documentList.length > 0) &&
          <Descriptions.Item label={ t('messages.aml.documents') } span={4}>
            <Table dataSource={ person.documentList } columns={ documentsTableColumns } pagination={ false } size='small' />
          </Descriptions.Item>
        }
        {
          (person.descriptions !== undefined && person.descriptions !== null && person.descriptions.length > 0) &&
          <Descriptions.Item label={ getTitle(person.origin) } span={4}>
            <Table dataSource={ person.descriptions } columns={ descriptionsColumns } pagination={ false } size='small' />
          </Descriptions.Item>
        }
        { (person.profileNotes !== undefined && person.profileNotes !== null) &&
          <Descriptions.Item label={ t('messages.aml.title.profileNotes') } span={4}>
            <pre style={{ whiteSpace: 'pre-wrap' }}>
              { person.profileNotes }
            </pre>
          </Descriptions.Item>
        }
        { (person.sourceDescription !== undefined && person.sourceDescription !== null && person.sourceDescription.length > 0) &&
          <Descriptions.Item label={ t('messages.aml.sources') } span={4} className="break-line">
            {person.sourceDescription.find(url => url.includes('https://global.factiva.com')) &&
              <p>Nota: Los link que comienzan con "https://global.factiva.com" son entregados por Factiva y requieren una suscripción que Gesintel <br/>administra en América Latina.</p>
            }
            { person.sourceDescription.map(item => <p dangerouslySetInnerHTML={{ __html: urlify(item) }} />) }
          </Descriptions.Item>
        }
      </Descriptions>
    </div>
  )
}

export default PersonInfoTabContent
